import { ColumnTypes, HyperLink } from '@/components';
import { ROUTERS } from '@/constant';

import { TFunction } from 'i18next';

export const getColumns = (
	t: TFunction<['common', 'contractedKorean']>,
	unitTypeJson: any,
	isShowHyperLink: boolean,
	fetchData: () => void
): ColumnTypes => [
	{
		align: 'center',
		title: 'ID',
		dataIndex: 'id',
		key: 'id',
		className: '!cursor-default',
		render: (id, record) =>
			isShowHyperLink ? (
				<HyperLink
					params={{
						id,
						pathname: ROUTERS.CM1_03,
					}}
					callback={fetchData}
				>
					{id}
				</HyperLink>
			) : (
				id
			),
	},
	{
		align: 'center',
		title: t('contractedKorean:type'),
		dataIndex: 'type',
		key: 'type',
		render: (unitType: string) => t((unitTypeJson[unitType] as any)?.label),
		className: '!cursor-default',
	},
	{
		align: 'center',
		title: t('contractedKorean:name'),
		dataIndex: 'name',
		key: 'name',
		className: '!cursor-default',
	},
	{
		align: 'center',
		title: t('contractedKorean:phone'),
		dataIndex: 'phone',
		key: 'phone',
		className: '!cursor-default',
	},
	{
		align: 'center',
		title: t('contractedKorean:address'),
		dataIndex: 'address',
		key: 'address',
		className: '!cursor-default',
	},
	{
		align: 'center',
		title: t('contractedKorean:author'),
		dataIndex: 'registName',
		key: 'registName',
		className: '!cursor-default',
	},
	{
		align: 'center',
		title: t('contractedKorean:registration-date'),
		dataIndex: 'registDt',
		key: 'registDt',
		className: '!cursor-default',
	},
];
